import React from 'react';
import PropTypes from 'prop-types';

const Description = ({ description = '', theme = {} }) =>
  description && (
    <div className={theme.description}>
      <div className={theme.descriptionText}>{description}</div>
    </div>
  );

export default Description;

Description.propTypes = {
  description: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
};
